import { useState, useMemo } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import OrderFilters from "../../Common/Filters/OrderFilters.jsx";
import PaginatorCom from "../../Paginator/PaginatorCom.jsx";
import { useSelector } from "react-redux";

export default function BasicTable({
  columns,
  data,
  SearchBy,
  handleSearch,
  handleFilter,
  handleClearFilter,
  filters,
  WeekRange,
  MonthRange,
  canlenderFilter,
  handleRowClick,
  onPaginatorClick,
  selectedData,
  handleCellClick,
  button_name,
  handleButton,
}) {
  const { theme } = useSelector((state) => state.theme);
  const [selected, setSelected] = useState(selectedData || null);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(5);

  const totalRecords = data?.length || 0;

  const paginatedData = useMemo(() => {
    if (!data || data.length === 0) return [];
    const start = first;
    const end = first + rows;
    return data?.slice(start, end);
  }, [data, first, rows]);

  const onPageChange = (e) => {
    setFirst(e.first);
    setRows(e.rows);
    onPaginatorClick?.(e);
  };

  const onRowClick = (e) => {
    const cellName = e.originalEvent.target.innerText;
    setSelected(e.data);
    handleRowClick?.(e.data, cellName);
  };

  return (
    <div className="w-full mb-28">
      <div
        className={`${
          theme
            ? "bg-secondaryColor text-gray-800"
            : "bg-darkThirsary text-gray-300"
        } shadow-2xl p-5 rounded-xl`}
      >
        <div className="filter">
          <OrderFilters
            filters={filters ? filters : []}
            SearchBy={SearchBy?.options.length ? SearchBy : { options: [] }}
            WeekRange={WeekRange ? WeekRange : false}
            MonthRange={MonthRange ? MonthRange : false}
            canlenderFilter={canlenderFilter}
            handleFilter={(name, value) => handleFilter?.(name, value)}
            handleClearFilter={() => handleClearFilter?.()}
            handleSearch={handleSearch ? handleSearch : null}
            actionButton={
              button_name &&
              handleButton && {
                button_name: button_name,
                handleButton: handleButton,
              }
            }
          />
        </div>

        <div className="overflow-x-auto">
          <DataTable
            value={paginatedData}
            onRowClick={onRowClick}
            selectionMode="single"
            selection={selected}
            onSelectionChange={(e) => setSelected(e.value)}
            dataKey="_id"
            scrollable
            scrollHeight="flex"
            className="min-w-max"
            pt={{
              headerRow: {
                style: {
                  backgroundColor: theme ? undefined : "#111827",
                },
              },
              headerCell: {
                style: {
                  backgroundColor: theme ? undefined : "#111827",
                  color: theme ? undefined : "#9ca3af",
                  fontWeight: 500,
                  borderBottom: theme ? undefined : "1px solid #1f2937",
                },
              },
              bodyRow: ({ state }) => ({
                style: {
                  backgroundColor: !theme
                    ? state?.selected
                      ? "#374151"
                      : "#111827"
                    : undefined,
                  color: !theme ? "#e5e7eb" : undefined,
                  transition: "background-color 0.15s ease",
                },
                onMouseEnter: (e) => {
                  if (!theme) e.currentTarget.style.backgroundColor = "#1f2937";
                },
                onMouseLeave: (e) => {
                  if (!theme)
                    e.currentTarget.style.backgroundColor = state?.selected
                      ? "#374151"
                      : "#111827";
                },
              }),
            }}
          >
            {columns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                body={(rowData) =>
                  col.accessor
                    ? col.accessor(rowData, handleCellClick)
                    : renderBody(rowData[col.field], handleCellClick)
                }
                className={`p-2.5 text-sm border-b ${
                  theme
                    ? "bg-secondaryColor text-gray-800"
                    : "bg-darkThirsary text-gray-300"
                }`}
                style={{ minWidth: col.minWidth || "150px" }}
              />
            ))}
          </DataTable>
        </div>

        <PaginatorCom
          paginatorData={{
            totalCount: totalRecords,
            rows,
            first,
          }}
          onPaginatorClick={onPageChange}
        />
      </div>
    </div>
  );
}

const renderBody = (data, handleCellClick) => {
  return (
    <div
      onClick={() => handleCellClick?.(data)}
      className="whitespace-nowrap overflow-hidden text-ellipsis"
    >
      {data}
    </div>
  );
};